import './styles.scss'
import apiFetch from '@wordpress/api-fetch'
import React, { useState, useEffect } from 'react'

export default function TagLineBlock({ postID }) {
  return (
    <div className={'dhsv-tag-line-block'}>
      <Taxomonies id={postID} />
    </div>
  )
}

const Taxomonies = ({ id }) => {
  const [postData, setPostData] = useState({
    term: {
      title: '',
      permalink: '',
      categories: '',
    },
  })

  const lang = document.documentElement.lang

  useEffect(() => {
    apiFetch({
      path:
        lang === 'en-US'
          ? '/en/wp-json/wp/v2/article/' + id
          : '/wp-json/wp/v2/article/' + id,
    }).then(data => {
      setPostData({
        term: {
          title: data.term.title,
          permalink: data.term.permalink,
          categories: data.term.categories,
        },
      })
    })
  }, [id])

  return (
    <div className={'tag-line-wrapper'}>
      <div className={'row'}>
        <div className={'col-12'}>
          <ul
            className={'tag-line__list'}
            dangerouslySetInnerHTML={{ __html: postData.term.categories }}
          />
        </div>
      </div>
    </div>
  )
}
